<template>
  <div class="mes-wrapper" :class="classObj">
    <div
      v-if="device === 'mobile' && open"
      class="mes-drawer mes-drawer--bg"
      @click="handleClickOutside">
    </div>
    <!-- 系统前台 -->
    <template v-if="hasWhiteList">
      <mes-home />
      <!-- 相同路由强制刷新 -->
      <router-view :key="$route.fullPath"/>
    </template>

    <!-- 第三方系统嵌入 -->
    <el-main v-else-if="isIframe">
      <navigation>
        <router-view />
      </navigation>
    </el-main>

    <!-- 系统后台 -->
    <template v-else-if="hasToken">
      <!-- 左侧菜单 -->
      <mes-sidebar />
      <!-- 右侧视图 -->
      <div class="mes-main">
        <!-- 上部导航 -->
        <mes-navbar />
        <!-- 应用渲染区 -->
        <el-main class="mes-main__content">
          <navigation>
            <router-view />
          </navigation>
        </el-main>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@/store';
import MesSidebar from './components/sidebar';
import MesNavbar from './components/navbar';
import MesHome from './components/home';
import { whiteList } from '@/config';
import resizeMixin from '@/mixins/resize';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    MesSidebar,
    MesNavbar,
    MesHome
  },
  mixins: [resizeMixin],
  computed: {
    ...mapGetters([
      'hasToken',
      'open',
      'withoutAnimation',
      'device'
    ]),
    // 白名单
    hasWhiteList() {
      return whiteList.includes(this.$route.path);
    },
    // 类
    classObj() {
      return {
        hide: !this.open,
        open: this.open,
        without: this.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    },
    // 是否是嵌入
    isIframe() {
      return store.state.isIframe;
    }
  },
  methods: {
    // 点击外部关闭侧边栏
    handleClickOutside() {
      this.$store.dispatch('closeSidebar', {
        withoutAnimation: false
      });
    }
  }
};
</script>

<style lang="scss">
@include b(wrapper) {
  width: 100%;
  height: 100%;
}
@include b(drawer) {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  @include m(bg) {
    background: $drawer-background-color;
  }
}
@include b(main) {
  position: relative;
  min-height: 100%;
  margin-left: $sidebar-width;
  transition: margin-left .28s;
  @include e(content) {
    min-height: calc(100vh - #{$header-height-base});
  }
}
</style>